module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8023.bfd3c2e1.png";